module.exports = __webpack_public_path__ + "img/FarmaciasEconomicas.e71db0d4.png";